import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getPersonalizedCategoriesQueryParams } from "@faire/retailer-shared/categories/categoryRequest";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { getNavigationTreeHashCode } from "@faire/retailer-visitor-shared/serialized-data/getNavigationTreeHashCode";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { findActiveCategoryByPathIdentifier } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByPathIdentifier";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { DEFAULT_LOCALE_KEY } from "@faire/web--source/common/consts/DEFAULT_LOCALE";
import { buildLocale } from "@faire/web--source/common/localization/utils";
import { QueryParameters as NonPersonalizedCategoriesParams } from "@faire/web-api--source/api/v3/categories/get";
import { useQuery as useCategoriesQuery, useInvalidateQuery as useInvalidateCategoriesQuery } from "@faire/web-api--source/api/v3/categories/get-hooks";
import { useQuery as usePersonalizedCategoriesQuery, useInvalidateQuery as useInvalidatePersonalizedCategoriesQuery } from "@faire/web-api--source/api/v3/categories/personalized/retailerToken/get-hooks";
import { useCallback, useMemo } from "react";
export var useCategoryStore = function() {
    var localeKey = getLocaleKey();
    var navigationTreeHashCode = getNavigationTreeHashCode();
    var retailerToken = useRetailer().retailerToken;
    var isInsider = useRetailerStore([
        "isInsider"
    ]).isInsider;
    var locale = buildLocale(localeKey !== null && localeKey !== void 0 ? localeKey : DEFAULT_LOCALE_KEY);
    var nonPersonalizedParams = useMemo(function() {
        return NonPersonalizedCategoriesParams.build({
            hashCode: navigationTreeHashCode,
            locale: locale,
            country: getSessionCountry()
        });
    }, [
        locale,
        navigationTreeHashCode
    ]);
    var personalizedParams = useMemo(function() {
        return getPersonalizedCategoriesQueryParams(locale, navigationTreeHashCode, isInsider);
    }, [
        isInsider,
        locale,
        navigationTreeHashCode
    ]);
    var _useCategoriesQuery = useCategoriesQuery(nonPersonalizedParams, {
        enabled: !retailerToken,
        staleTime: Infinity
    }), categoriesData = _useCategoriesQuery.data, isCategoriesFetching = _useCategoriesQuery.isFetching;
    var _usePersonalizedCategoriesQuery = usePersonalizedCategoriesQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", personalizedParams, {
        enabled: !!retailerToken,
        staleTime: Infinity
    }), personalizedCategoriesData = _usePersonalizedCategoriesQuery.data, isPersonalizedCategoriesFetching = _usePersonalizedCategoriesQuery.isFetching;
    var _categoriesData_category_list;
    var categories = (_categoriesData_category_list = categoriesData === null || categoriesData === void 0 ? void 0 : categoriesData.category_list) !== null && _categoriesData_category_list !== void 0 ? _categoriesData_category_list : personalizedCategoriesData === null || personalizedCategoriesData === void 0 ? void 0 : personalizedCategoriesData.category_list;
    var categoriesLoading = isCategoriesFetching || isPersonalizedCategoriesFetching || categories === undefined;
    var shouldShowVerticalTile = useCallback(function(pathIdentifier) {
        var _categoriesForPathIdentifier_tree_node_metadata;
        if (pathIdentifier === undefined) {
            return false;
        }
        var categoriesForPathIdentifier = findActiveCategoryByPathIdentifier(pathIdentifier, categories !== null && categories !== void 0 ? categories : []);
        return !!(categoriesForPathIdentifier === null || categoriesForPathIdentifier === void 0 ? void 0 : (_categoriesForPathIdentifier_tree_node_metadata = categoriesForPathIdentifier.tree_node_metadata) === null || _categoriesForPathIdentifier_tree_node_metadata === void 0 ? void 0 : _categoriesForPathIdentifier_tree_node_metadata.show_vertical_tile);
    }, [
        categories
    ]);
    var invalidateCategories = useInvalidateCategoriesQuery();
    var invalidatePersonalizedCategories = useInvalidatePersonalizedCategoriesQuery();
    var refetchCategories = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (retailerToken) {
                invalidatePersonalizedCategories(retailerToken, personalizedParams);
            } else {
                invalidateCategories(nonPersonalizedParams);
            }
            return [
                2
            ];
        });
    }), [
        retailerToken,
        invalidatePersonalizedCategories,
        personalizedParams,
        invalidateCategories,
        nonPersonalizedParams
    ]);
    return {
        categories: categories,
        categoriesLoading: categoriesLoading,
        shouldShowVerticalTile: shouldShowVerticalTile,
        refetchCategories: refetchCategories
    };
};
